export class OtpDataForm {

    otp: String;
    userName: string;
    passWord: string;
    constructor() {
    }
}
